import omit from 'lodash/omit'
import api from 'api'
import {
  CACHE_TAG_ROUTES,
  CACHE_TAG_ROUTES_STOPS,
  CACHE_TAG_ROUTES_GEOJSON,
  CACHE_TAG_ROUTES_UNASSIGNED_WORK_ORDERS,
  CACHE_TAG_ROUTES_METADATA_BY_DATE,
} from 'api/cacheTagTypes'

const STOP_MUTATION_TAGS = [
  CACHE_TAG_ROUTES,
  CACHE_TAG_ROUTES_STOPS,
  CACHE_TAG_ROUTES_GEOJSON,
  CACHE_TAG_ROUTES_UNASSIGNED_WORK_ORDERS,
  CACHE_TAG_ROUTES_METADATA_BY_DATE,
]

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    moveStops: builder.mutation({
      query: body => ({ url: '/api/v1/core/route/stops', method: 'POST', body }),
    }),
    bulkMoveStops: builder.mutation({
      query: body => ({
        url: '/api/v1/core/route/stops/bulk',
        method: 'POST',
        body: omit(body, ['skipInvalidate']),
        timeout: 90000,
      }),
      invalidatesTags: (result, error, arg) => (arg?.skipInvalidate ? [] : STOP_MUTATION_TAGS),
    }),
  }),
})

export const { useMoveStopsMutation, useBulkMoveStopsMutation } = extendedApi
